/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Jobs_TitleInputs */

const en_candidate_jobs_title = /** @type {(inputs: Candidate_Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available Jobs`)
};

const de_candidate_jobs_title = /** @type {(inputs: Candidate_Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Jobs`)
};

/**
* | output |
* | --- |
* | "Available Jobs" |
*
* @param {Candidate_Jobs_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_jobs_title = /** @type {((inputs?: Candidate_Jobs_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Jobs_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_jobs_title(inputs)
	return en_candidate_jobs_title(inputs)
});